import React from 'react';

import { AuthService } from '../../services/AuthService';

export interface IAuthContext {
  isAuthenticated: boolean;
  user?: AuthService['user'];

  login: (back?: string) => void;
  logout: (back?: string) => void;
}

export const AuthContext = React.createContext<IAuthContext | undefined>(undefined);
